import { PopupType } from '../../../components/popup/types';
import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export interface DealerMessage extends GameCommunicationMessageType {
  id?: string;
  value?: string;
}

export class GameCommunicationDealerProcessor implements IGameCommunicationProcessor {
  messageName = 'dealer';

  process(message: DealerMessage, store: CoreStoreType): void {
    if (message?.value) {
      store.dispatch(
        gameStateActions.setDealer({
          id: message?.id || null,
          name: message.value,
        })
      );

      if (message.value?.toUpperCase() === 'NO DEALER') {
        store.dispatch(popupActions.pushPopup(PopupType.TableClosed));
        store.dispatch(gameStateActions.setGamePaused(true));
      } else {
        store.dispatch(popupActions.dismissPopup(PopupType.TableClosed));
        store.dispatch(gameStateActions.setGamePaused(false));
      }
    } else {
      Logger.logError('GameCommunicationController', 'error', Date.now(), 'dealer', 'dealer message is not valid');
    }
  }
}
